import { styled } from '@openeducation/pp-rn-themes';
import React, { ReactNode } from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

import { PPText } from '../../atoms';

export interface FormSectionProps {
  children: ReactNode;
  title: string;
  style?: StyleProp<ViewStyle>;
  withCardStyle?: boolean;
}

export const FormSection = ({
  style,
  title,
  children,
  withCardStyle = false,
}: FormSectionProps) => {
  return (
    <Container style={style} withCardStyle={withCardStyle}>
      <Title>{title}</Title>
      {children}
    </Container>
  );
};

const Container = styled.View<{ withCardStyle: boolean }>`
  margin-top: ${({ theme }) => theme.spacing.medium}px;
  ${({ withCardStyle, theme }) =>
    withCardStyle &&
    `
      background-color: ${theme.colors.light};
      padding: ${theme.spacing.large}px;
      border-radius: ${theme.border.radius.medium}px;
    `}
`;

export const Title = styled(PPText).attrs({
  fontSize: 24,
  fontType: 'medium',
})`
  margin-bottom: ${({ theme }) => theme.spacing.primarySmall}px;
`;

export default FormSection;
